import { render, staticRenderFns } from "./NewPrescriptionModal.vue?vue&type=template&id=4d9b2fc9"
import script from "./NewPrescriptionModal.vue?vue&type=script&lang=js"
export * from "./NewPrescriptionModal.vue?vue&type=script&lang=js"
import style0 from "./NewPrescriptionModal.vue?vue&type=style&index=0&id=4d9b2fc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports